import React from 'react';
import ButtonComp from '../components/button';
import { Link } from 'react-router-dom';
interface HaishaBonusProps {
    setShowTranDet: any;
}

export const HaishaBonus: React.FC<HaishaBonusProps> = (props: HaishaBonusProps) => {
    const { setShowTranDet } = props;

    const path = window.location.pathname;
    const pathParams = path.split('/')

    const handleNoClick = () => {
        setShowTranDet(false)
    }
    
    const handleYesClick = () => {
        const androidStoreLink = 'https://play.google.com/store/apps/details?id=com.basant_loyalty';
        const iosStoreLink = 'https://apps.apple.com/in/app/haisha-champions-club-app/id6448427578';
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        const isAndroid = /android/i.test(navigator.userAgent);
        if (isIOS) {
            window.location.replace(iosStoreLink);
        } else if (isAndroid) {
            window.location.replace(androidStoreLink);
        } else {
            window.location.replace(androidStoreLink);
        }
    }

    return (
        <div className='haisha-bonus-main'>
            Don’t miss out on Surprise Bonus Reward, scan the token in HAISHA Champions
            Club (HCC) app & get bonus scratch card. To download & login
            <div className='surprise-bonus-buttons'>
                <ButtonComp label={'Yes'}
                    name={'YES'}
                    visible={true}
                    handleToUpdate={handleYesClick} />
                <ButtonComp label={'No'}
                    name={'NO'}
                    visible={true}
                    handleToUpdate={handleNoClick} />
            </div>
        </div>
    )
}

export default HaishaBonus;